import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetVirtualTourQuery = (tourId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["virtual-tour", tourId],
    enabled: !!tourId,
    queryFn: async () => {
      const { data } = await authApi.get<
        VirtualTour & { hotspots: Array<Hotspot> }
      >(`/virtual-tour/${tourId}`);
      return data;
    },
  });

  return result;
};
